export default __webpack_public_path__ + "static/media/Ever-repeating Performance.09c132a3.png";